{
    "nswfuelwatch": {
        "basePath": ""
    }
}
